import { ConnectFlowModel, FullAudit, VueFlowNodeModel, VueFlowConnectionModel } from '@/types';

export interface ConnectFlowFlowModel extends FullAudit {
    id: number;
    connectFlowId: number;
    connectFlow: ConnectFlowModel;
    flow: (VueFlowNodeModel | VueFlowConnectionModel)[];
}
